export default "__VITE_ASSET__B8odddJ1__"